// extracted by css-extract-rspack-plugin
export default {"rowEmphasised":"TZ2JY6tq","disabled":"Uyx47vNR","rowContent":"tlz0hLKG","row":"xo1WBrtN","alignRight":"ZEAbdUDP"};